<template>
  <img
    src="~/assets/icon/icon-menu.svg"
    alt=""
  />
</template>
